import { useState } from "react";
import { useAnim, useSEO } from "../hooks.jsx";
import { Link } from "react-router-dom";
import { FAQS, PAGE_SEO, SCHEMA_FAQ, BREADCRUMBS, BREADCRUMB_ITEMS } from "../data.js";
import Breadcrumb from "../components/Breadcrumb.jsx";
import CtaBand from "../components/CtaBand.jsx";

export default function FAQ({ go }) {
  const [open, setOpen] = useState(null);
  useAnim();
  useSEO({ ...PAGE_SEO.faq, schema: [SCHEMA_FAQ, BREADCRUMBS.faq] });

  return (
    <>
      <Breadcrumb items={BREADCRUMB_ITEMS.faq} />
      <section className="ph">
        <div className="ph-in an">
          <div className="chip">FAQ</div>
          <h1 className="h2" style={{ fontSize:"clamp(1.9rem,4vw,2.9rem)" }}>
            Domande <mark>frequenti</mark>
          </h1>
          <p className="lead" style={{ marginTop:".65rem" }}>
            Tutto quello che vuoi sapere prima di iniziare.{" "}
            <Link to="/contatti" style={{ color:"var(--blue)", fontWeight:600 }}>
              Non trovi la risposta? Scrivici.
            </Link>
          </p>
        </div>
      </section>

      <section className="sec" style={{ background:"var(--bg)" }}>
        <div className="wrap">
          <div className="fw">
            {FAQS.map((f, i) => (
              <div className="an" key={i}>
                <div className={`fi2${open === i ? " op" : ""}`}>
                <button className="fq" onClick={() => setOpen(open === i ? null : i)} aria-expanded={open === i}>
                  <span className="fqt">{f.q}</span>
                  <span className="fic">+</span>
                </button>
                <div className={`fa${open === i ? " op" : ""}`}>{f.a}</div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA card */}
          <div className="an" style={{ textAlign:"center", padding:"2.5rem", background:"#fff", border:"1.5px solid var(--border)", borderRadius:"var(--rl)", maxWidth:"520px", margin:"3.5rem auto 0" }}>
            <div style={{ fontSize:"2.5rem", marginBottom:".85rem", color:"var(--blue)" }}>?</div>
            <h3 className="j" style={{ fontSize:"1.15rem", fontWeight:800, color:"var(--ink)", marginBottom:".45rem" }}>
              Non hai trovato la risposta?
            </h3>
            <p style={{ fontSize:".9rem", color:"var(--muted)", marginBottom:"1.5rem", lineHeight:1.7 }}>
              Scrivici, ti risponderemo entro 24 ore lavorative.
            </p>
            <Link to="/contatti" className="btn btn-p" style={{ textDecoration:"none" }}>Contattaci</Link>
          </div>
        </div>
      </section>

      <CtaBand go={go} />
    </>
  );
}
